import { getPersistedSessionValue, setPersistedSessionValue, removePersistedSessionValue } from '../session-persistence';

const normalizeReportId = (value) => {
    if (value == null) return '';
    const normalized = String(value).trim();
    return normalized.length ? normalized : '';
};

const canUseBrowserStorage = () => (
    typeof window !== 'undefined'
    && typeof document !== 'undefined'
);

export const getPersistedReportId = () => {
    if (!canUseBrowserStorage()) return '';

    return normalizeReportId(sessionStorage.getItem('rid'))
        || normalizeReportId(getPersistedSessionValue('rid'));
};

export const persistReportId = (reportId) => {
    if (!canUseBrowserStorage()) return '';

    const normalizedReportId = normalizeReportId(reportId);
    if (!normalizedReportId) return '';

    setPersistedSessionValue('rid', normalizedReportId);
    sessionStorage.setItem('rid', normalizedReportId);

    return normalizedReportId;
};

export const hydrateReportId = () => {
    const persistedReportId = getPersistedReportId();
    if (!persistedReportId || !canUseBrowserStorage()) return '';

    if (sessionStorage.getItem('rid') !== persistedReportId) {
        sessionStorage.setItem('rid', persistedReportId);
    }

    setPersistedSessionValue('rid', persistedReportId);
    return persistedReportId;
};

export const clearPersistedReportId = () => {
    if (!canUseBrowserStorage()) return;
    removePersistedSessionValue('rid');
    sessionStorage.removeItem('rid');
};
